import i18next from 'i18next';

const namespace = 'resetPassword';
const config = {
  zh: {
    'Account Information': '用户信息',
    'Change Password': '修改密码',
    'Password Changed Successfully': '密码修改成功',
    Return: '返回',
    'Verify Current Password': '验证旧密码',
    'Enter New Password': '设置新密码',
    Complete: '完成',
  },
  en: {
    'Account Information': 'Account Information',
    'Change Password': 'Change Password',
    'Password Changed Successfully': 'Password Changed Successfully',
    Return: 'Return',
    'Verify Current Password': 'Verify Current Password',
    'Enter New Password': 'Enter New Password',
    Complete: 'Complete',
  },
};

Object.keys(config).forEach((key) => {
  i18next.addResources(key, namespace, config[key]);
});
